import React from 'react';
import './DropdownSearch.css';
import Select from 'react-select';

const genreAPI = "https://api.ctrlv.ca/api/corp/getGenres";
const genres = {
  'all': "All",
  15: "Action",
  23: "Adventure",
  24: "Casual",
  245: "Family",
  91: "Horror",
  27: "Minigames",
  28: "Motion",
  29: "Puzzle",
  659: "Sports",
  554: "Shooter",
  25: "Experiential"
}


class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      checkboxes: [],
      error: null
    };

    this.selectOption = this.selectOption.bind(this);
  }

  componentDidMount() {
    fetch(genreAPI)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .then(data => this.setState({ checkboxes: data }))
      .catch(error => this.setState({ error }));
  }

  onGenreChange(e) {
    this.props.onGenreFilterChange(e.value);
  }

  selectOption(e) {
    this.setState({ value: e });
    this.onGenreChange(e);
  }

  render() {
    const error = this.state.error;
    const bigList = [];

    if (error) {
      return <p>{error.message}</p>;
    }

    bigList.push({ value: 'all', label: 'All' });
    this.state.checkboxes.map(checkbox => bigList.push({ value: checkbox.genre_id, label: checkbox.genre_name }));

    var displayTitle = genres[this.props.displayGenreFilter];

    return (
      <div className="box">
        <div className="col">
          <p>Genres</p>
        </div>
        <Select
          options={bigList}
          onChange={this.selectOption}
          defaultValue = {{ label: displayTitle, value: this.props.displayGenreFilter }} />
      </div>
    );
  }
}



export default Dropdown;
